import * as TYPES from './types'

/**
 * Default PublicApi State
 */
const initialState: TYPES.PublicApiState = {
    httpInProgress: false,
    httpError: '',
    submitted: false,
}

// define publicApi reducer
export function publicApiReducer (
    state = initialState,
    action: TYPES.PublicApiActionTypes
): TYPES.PublicApiState {
    switch (action.type) {
        case TYPES.PUBLIC_API_EA_IN_PROGRESS: {
            return { ...state, httpInProgress: true, httpError: '', submitted: false }
        }
        case TYPES.PUBLIC_API_EA_SUCCESS: {
            return { ...state, httpInProgress: false, httpError: '', submitted: true }
        }
        case TYPES.PUBLIC_API_EA_ERROR: {
            return { ...state, httpInProgress: false, httpError: action.error }
        }
        default:
            return state
    }
}
